import { Paginator, SortDirection } from '@app/classes';
import { SelectFilter } from '@app/modules/table/classes/table-filters/select-filter.class';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import { TimeOffTransaction } from '@models/time-off-v3/time-off-transaction.model';
import { TimeOffType } from '@models/time-off-v3/time-off-type.model';
import { BalanceColumn } from './columns/balance.column';
import { ChangeColumn } from './columns/change.column';
import { DescriptionColumn } from './columns/description.column';
import { TransactionDateColumn } from './columns/transaction-date.column';

export class TimeOffTransactionTable extends Table {
    static deleteOption: MenuColumnItem = {
        label: 'delete',
        event: 'delete',
    };

    showMenuColumnOptions = true;
    sortDirection = SortDirection.DESC;
    isPolicyUnlimited = false;
    protected sortProperty = 'processedAt';

    constructor(
        protected auth: AuthService,
        private employeeId: number,
        private endDate: string,
        private timeOffTypes: TimeOffType[] = [],
        private activeTimeOffPolicies: TimeOffPolicy[] = []
    ) {
        super(auth);

        const timeOffTypeOptions = timeOffTypes.map((timeOffType: TimeOffType) => {
            return { label: timeOffType.name, value: timeOffType.id };
        });

        const timeOffTypeFilter = new SelectFilter('timeOffTypeId', timeOffTypeOptions, {
            initialSelection: timeOffTypeOptions[0],
            nullable: false,
        });

        timeOffTypeFilter.label = 'time-off-v3.type';

        timeOffTypeFilter.onChanges.subscribe((values) => {
            this.isPolicyUnlimited = this.activeTimeOffPolicies.find(
                (timeOffPolicy) => timeOffPolicy.timeOffTypeId === values[0].value
            ).isUnlimited;
        });

        this.filters = [timeOffTypeFilter];

        this.boot();
    }

    setColumns(): void {
        const transactionDateColumn = new TransactionDateColumn();

        this.sortColumn = transactionDateColumn;
        this.columns = [
            transactionDateColumn,
            new DescriptionColumn(),
            new ChangeColumn(this.timeOffTypes),
            new BalanceColumn(this.timeOffTypes),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            TimeOffTransaction.where('employeeId', this.employeeId).where('processedAt', {
                to: this.endDate,
            })
        );
    }

    getMenuColumnOptionsForRow(timeOffTransaction: TimeOffTransaction): MenuColumnItem[] {
        if (this.auth.isAdmin() && timeOffTransaction.isAdminAdjustment) {
            return [TimeOffTransactionTable.deleteOption];
        }

        return [];
    }
}
